// import AdmPanel from './AdmPanel';
import AdmLinkGroup from './AdmLinkGroup';


export default function(Vue){
  // Vue.component('AdmPanel', AdmPanel);
  Vue.component('AdmLinkGroup', AdmLinkGroup);
}
